import type { ReactNode } from "react";

import { Label } from "@monorepo-apps/ui/src/components/label";

/**
 * The uppercase micro-label + control pairing every delivery-tasks form uses.
 * Shared so the three forms (sprint dialog, create-task dialog, task drawer)
 * can't drift apart.
 */
export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label className="text-muted-foreground text-[10px] tracking-wider uppercase">{label}</Label>
      {children}
    </div>
  );
}
